import Stages from "Constant/Stages";
import { ActivityTimeLogType } from "DataTypes/Services/Patient.type"

const FilterCareplanActivity: (
  activityArr: ActivityTimeLogType[]
) => ActivityTimeLogType[] = (activityArr) => {
  return activityArr.filter(el => {
    // teamIntiatedSlug: "caremanager" || "provider"
    // loginUserSlug: "caremanager" || "provider" || "billable provider"
    // provider == Rendering Provider
    // billable provider == Care Plan Rendering Provider
    if (el.abbreviation == "CCM") {
      if (el.activity.search("Careplan") != -1) {
        if (el.teamIntiatedSlug == "caremanager") {
          if (el.loginUserSlug == "caremanager") return el;
          if (
            el.loginUserSlug == "provider"
            && el.careplanState != Stages.Recurring
          ) return el
        } else {
          if (el.loginUserSlug == "billable provider") return el;
          if (
            el.loginUserSlug == "provider" &&
            el.careplanState == Stages.Recurring
          ) return el;
        }
      } else return el
    } else if (el.abbreviation == "PCM") {
      if (el.activity.search("Careplan") != -1) {
        if (el.teamIntiatedSlug == "caremanager") {
          if (
            el.loginUserSlug == "caremanager" ||
            el.loginUserSlug == "provider"
          ) return el;
        } else {
          if (el.loginUserSlug == "billable provider") return el;
          if (
            el.loginUserSlug == "provider" &&
            el.careplanState == Stages.Recurring
          ) return el;
        }
      } else return el
    } else if (el.abbreviation == "BHI" || el.abbreviation == "APCM") {
      if (el.activity.search("Careplan") != -1) {
        if (el.teamIntiatedSlug == "caremanager") {
          if (
            el.loginUserSlug == "caremanager" ||
            el.loginUserSlug == "provider"
          ) return el;
        } else {
          if (el.loginUserSlug == "billable provider") return el;
          if (
            (
              el.loginUserSlug == "provider" ||
              el.loginUserSlug == "caremanager"
            ) && el.careplanState == Stages.Recurring
          ) return el;
        }
      } else if (el.activity.search("Revision") != -1) {
        if (el.teamIntiatedSlug == "caremanager") {
          if (
            el.loginUserSlug == "caremanager" ||
            el.loginUserSlug == "provider"
          ) return el;
        } else if (
          el.teamIntiatedSlug == "provider" &&
          el.loginUserSlug == "provider"
        ) return el;
        else if (
          el.teamIntiatedSlug == "billable provider" &&
          el.loginUserSlug == "billable provider"
        ) return el;
      } else return el
    } else return el;
  })
}

export { FilterCareplanActivity }